import React, { useEffect, useState } from 'react';
import { colors } from './styles'
import Project from './Project'
import Field from './Field'

import { getProjects } from '../functions/firebaseFunctions';
import { auth } from "../functions/firebaseFunctions";
import { onAuthStateChanged } from "firebase/auth";

const CardStyle = {
    width: '100%',
    borderRadius: '10px',
    border: 'solid 2px var(--orng)',
    padding: '10px 20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: 'var(--white)',
    transition: '200ms',
    maxWidth: 300,
    margin: 10
}

export default function Projects() {
    const [projects, setProjects] = useState(undefined);
    const [user, setUser] = useState(undefined);// if user is undefined then it has not been fethced
    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            if (user) {
                setUser(user)
            } else {
                setUser(null); // if user is null it has been fetched and the user is not logged in
            }
        });
        getProjects().then(gPs_res => {
            setProjects(gPs_res);
        }).catch(error => { console.error(error) })
    }, []);
    return (
        <section style={{
            backgroundColor: colors.mdGray,
            width: '100%',
            padding: '10px 20px',
            marginTop: 20,
        }}>
            <h2 style={{ color: colors.org, textAlign: 'center' }}>Projects</h2>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: "center" }}>
                {user &&
                    <div style={CardStyle} className='popUp'>
                        <Field
                            type='h3'
                            value="Enter Title"
                            color="white"
                            width={230}
                            fieldPath={`projects`}
                            newProj
                        />
                        <hr style={{ borderColor: 'var(--white)', borderWidth: 1 }} />
                        <p>To create a new project enter it's title</p>
                    </div>}
                {projects && projects.map(project => <Project project={project} key={project.title} CardStyle={CardStyle} />)}
            </div>
        </section>
    );
}